// extracted by mini-css-extract-plugin
module.exports = {"branchContainer":"branches_branchContainer__+KJi3"};